var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2289",
    "data-name": "Group 2289",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.507,
    height: 27.507,
    viewBox: "0 0 27.507 27.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M0,0H27.507V27.507H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M23.63,22.484a1.146,1.146,0,0,1-1.146,1.146H4.146A1.146,1.146,0,0,1,3,22.484V4.146A1.146,1.146,0,0,1,4.146,3H22.484A1.146,1.146,0,0,1,23.63,4.146ZM12.169,5.292H5.292V21.338h6.877Zm9.169,9.169H14.461v6.877h6.877Zm0-9.169H14.461v6.877h6.877Z",
    transform: "translate(0.438 0.438)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleIcon);
export default __webpack_public_path__ + "static/media/role-icon.b913062a79f4ce8958c64f9baaafefca.svg";
export { ForwardRef as ReactComponent };